<script>
export default {
  computed: {
    tdDynamicSize: function () {
      return this.editable ? '60%' : '80%'
    }
  }
}
</script>
